export default __webpack_public_path__ + "static/media/img-0026.ba9d2c5f.png";